module.exports = __webpack_public_path__ + "market/static/img/poker_start.06ec6ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/poker_start.png
// module id = Yf2v
// module chunks = 1